/**
 * CSS Loading Fallback Script
 * Ensures async CSS loads properly and provides fallback for older browsers
 */

(function () {
  'use strict';

  // Check if we need to load the async CSS
  function loadAsyncCSS() {
    const asyncCSS = document.querySelector('link[rel="preload"][as="style"]');
    if (asyncCSS && !asyncCSS.onload) {
      // Fallback for browsers that don't support onload on link elements
      asyncCSS.rel = 'stylesheet';
    }
  }

  // Load CSS immediately if page is already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadAsyncCSS);
  } else {
    loadAsyncCSS();
  }

  // Fallback for very old browsers
  setTimeout(loadAsyncCSS, 100);
})();
